module.exports = __webpack_public_path__ + "static/media/396JamesPBrawleyDrNW_2018-06-12_164.5f2f6455.jpg";